import './App.css';
import {AvatarBuilder} from "./AvatarBuilder";
import {UserInput} from "./UserInput";
import {StartButton} from "./StartButton";
import {useState} from "react";
import {AVAILABLE_BODIES, AVAILABLE_FACES, AVAILABLE_HAIRSTYLES, DEFAULT_NAMES} from "./assets";
import logo from './resources/logo/LOGO.png';
import Background from './resources/logo/splash-background.png'


function App() {

    // Welcome loader
    const [showWelcome, setShowWelcome] = useState(true);
    setTimeout(() => setShowWelcome(false), 3000);

    // Avatar Components
    const [userName, setUserName] = useState(DEFAULT_NAMES[Math.floor(Math.random() * DEFAULT_NAMES.length)]);
    const [bodyIndex, setBodyIndex] = useState(Math.floor(Math.random() * AVAILABLE_BODIES.length));
    const [faceIndex, setFaceIndex] = useState(Math.floor(Math.random() * AVAILABLE_FACES.length));
    const [hairIndex, setHairIndex] = useState(Math.floor(Math.random() * AVAILABLE_HAIRSTYLES.length));

    // Avatar Custom Colors
    const [customHairColor, setCustomHairColor] = useState("#" + Math.floor(Math.random()*16777215).toString(16))
    const [customSkinColor, setCustomSkinColor] = useState("#" + Math.floor(Math.random()*16777215).toString(16))
    const [customClothesColor, setCustomClothesColor] = useState("#" + Math.floor(Math.random()*16777215).toString(16))

    return (
    <div className="App">
        {showWelcome && <div className={"welcome-screen"} style={{backgroundImage: `url(${Background})`, backgroundSize: "contain"}}>
            <img src={logo} alt={"innoarcade logo"} className={"arcade-logo"}></img>
        </div>}
        {!showWelcome &&
            <header className="App-header">
                <UserInput initialUserName={userName}
                     setUserName={setUserName}/>
          <AvatarBuilder bodyIndex={bodyIndex}
                         faceIndex={faceIndex}
                         hairIndex={hairIndex}
                         customHairColor={customHairColor}
                         customSkinColor={customSkinColor}
                         customClothesColor={customClothesColor}
                         setBodyIndex={setBodyIndex}
                         setFaceIndex={setFaceIndex}
                         setHairIndex={setHairIndex}
                         setCustomHairColor={setCustomHairColor}
                         setCustomSkinColor={setCustomSkinColor}
                         setCustomClothesColor={setCustomClothesColor}
          />
          <StartButton bodyIndex={bodyIndex}
                       faceIndex={faceIndex}
                       hairIndex={hairIndex}
                       customHairColor={customHairColor}
                       customSkinColor={customSkinColor}
                       customClothesColor={customClothesColor}
                       userName={userName}
          />
      </header>
        }
    </div>
  );
}

export default App;
